import IndexModule from "modules/index/index.module";
import React from "react";

const IndexPage = () => {
  return (
    <div>
      <IndexModule />
    </div>
  );
};

export default IndexPage;
